/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { X, Expand, History } from "lucide-react";
import CustomInput from "../../../../components/CustomInput";
import costSheetTemplate from "../costSheetTemplate";
import "react-quill/dist/quill.snow.css";
import { PrimaryButton, OutlineButton } from "../../../../components/Buttons";
import PropertyBuyerDetails from "../../../../components/SaleSteps/PropertyBuyerDetails";
import { Input, Spinner } from "@material-tailwind/react";
import axiosInstance from "../../../../services/api/axios";
import { toast } from "react-toastify";
import { useUser } from "../../../../context/UserContext";


const CostSheetFormModal = ({
    costSheetData: initialCostSheetData, // Renamed for clarity
    isOpen,
    onClose,
    onSendDocument,
    sendLoading,
    property,
    customers,
    onLoginIdSelect,
    onCommentChange,
    onCustomerSelect,
    approver,
    selectedUser,

}) => {
    const [costSheetData, setCostSheetData] = useState({ // Local state!
        name: "",
        property_type: "",
        property_no: "",
        building_no: "",
        floor: "",
        property_type_desc: "",
        carpetAreaSqmt: 0,
        carpetAreaSqft: 0,
        balconyAreaSqmt: 0,
        balconyAreaSqft: 0,
        dryBalconyAreaSqmt: 0,
        dryBalconyAreaSqft: 0,
        superBuiltupAreaSqmt: 0,
        superBuiltupAreaSqft: 0,
        base_price: 0,
        floor_rise: 0,
        stamp_duty: 0,
        registration_price: 0,
        gst: 0,
        cost_sheet_terms: "",
        legalCharges: 0,
        grossGovernmentCharges: 0,
        mseb: 0,
        infraCharges: 0,
        societyFormationCharges: 0,
        stampDutyParking: 0,
    });

    const { userInfo } = useUser();
    const [mseb, setMseb] = useState(0);
    const [infraCharges, setInfraCharges] = useState(0);
    const [societyFormationCharges, setSocietyFormationCharges] = useState(0);
    const [stampDutyParking, setStampDutyParking] = useState(0);
    const [legalCharges, setLegalCharges] = useState(0);
    const [grossGovernmentCharges, setGrossGovernmentCharges] = useState(0);
    const [costSheetTerms, setCostSheetTerms] = useState('');
    const [localMseb, setLocalMseb] = useState(0);
    const [localInfraCharges, setLocalInfraCharges] = useState(0);
    const [localSocietyFormationCharges, setLocalSocietyFormationCharges] = useState(0);
    const [localStampDutyParking, setLocalStampDutyParking] = useState(0);
    const [localLegalCharges, setLocalLegalCharges] = useState(0);
    const [localGrossGovernmentCharges, setLocalGrossGovernmentCharges] = useState(0);
    const [localCostSheetTerms, setLocalCostSheetTerms] = useState('');
    const [previewHtml, setPreviewHtml] = useState("");
    const [step, setStep] = useState(1);
    const [totalB, setTotalB] = useState(0);
    const [totalC, setTotalC] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [isFullScreen, setIsFullScreen] = useState(false); // State for full-screen preview
   

    const [formData, setFormData] = useState({
        saleDate: '',
        basePrice: 0,
        stampDuty: 0,
        gst: 0,
        registrationPrice: 0,
        currencyId: null,
        customerBankEmail: '',
        paymentOption: '',
        customerId: '',
        agentId: ''
    });

    // New state variables for percentages and calculated values
    const [selectedStampDutyPercent, setSelectedStampDutyPercent] = useState("");
    const [selectedGstPercent, setSelectedGstPercent] = useState("");
    const [selectedRegistrationPercent, setSelectedRegistrationPercent] = useState("");

    // Access configuration object
    const [stampDutyPercentsDropDown, setStampDutyPercentsDropDown] = useState(property?.projectPhase?.project?.configuration?.stampDutyPercent || []);
    const [gstPercentsDropDown, setGstPercentsDropDown] = useState(property?.projectPhase?.project?.configuration?.gstPercent || []);
    const [registrationPercentsDropDown, setRegistrationPercentsDropDown] = useState(property?.projectPhase?.project?.configuration?.registrationPercent || []);

    const [approvalDetails, setApprovalDetails] = useState({
        approver: '',
        comment: ''
    });

    const [approverStaffLogins, setApproverStaffLogins] = useState([]);
    const [selectedLoginId, setSelectedLoginId] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null); // to handle the selected customer detail
    const [approvalNeeded, setApprovalNeeded] = useState(false);  // New state
    const [comment, setComment] = useState(""); // To handle the comment input
    const [isSending, setIsSending] = useState(false); // Local loading state for send without approval

    useEffect(() => {
        if (initialCostSheetData) {
            setCostSheetData(initialCostSheetData);
        }
        setMseb(property?.mseb || 0);
        setInfraCharges(property?.infraCharges || 0);
        setSocietyFormationCharges(property?.societyFormationCharges || 0);
        setStampDutyParking(property?.stampDutyParking || 0);
        setLegalCharges(property?.legalCharges || 0);
        setGrossGovernmentCharges(property?.grossGovernmentCharges || 0);
        setCostSheetTerms(property?.costSheetTerms || '');
        setStampDutyPercentsDropDown(property?.propertyConfigData?.projectPhase.project?.configuration?.stampDutyPercent || [])
        setGstPercentsDropDown(property?.propertyConfigData?.projectPhase.project?.configuration?.gstPercent || [])
        setRegistrationPercentsDropDown(property?.propertyConfigData?.projectPhase.project?.configuration?.registrationPercent || [])
    }, [initialCostSheetData, property]);

    useEffect(() => {
        setLocalMseb(mseb);
        setLocalInfraCharges(infraCharges);
        setLocalSocietyFormationCharges(societyFormationCharges);
        setLocalStampDutyParking(stampDutyParking);
        setLocalLegalCharges(legalCharges);
        setLocalGrossGovernmentCharges(grossGovernmentCharges);
        setLocalCostSheetTerms(costSheetTerms)
    }, [mseb, infraCharges, societyFormationCharges, stampDutyParking, legalCharges, grossGovernmentCharges, costSheetTerms]);

    useEffect(() => {
        const calculatedTotalB =
            parseFloat(localMseb || 0) +
            parseFloat(localInfraCharges || 0) +
            parseFloat(societyFormationCharges || 0) +
            parseFloat(costSheetData?.floor_rise || 0);
        setTotalB(calculatedTotalB.toFixed(2));
    }, [localMseb, localInfraCharges, localSocietyFormationCharges, costSheetData?.floor_rise]);

    useEffect(() => {
        const calculatedTotalC =
            parseFloat(costSheetData?.stamp_duty || 0) +
            parseFloat(stampDutyParking || 0) +
            parseFloat(costSheetData?.registration_price || 0) +
            parseFloat(costSheetData?.gst || 0) +
            parseFloat(legalCharges || 0) +
            parseFloat(grossGovernmentCharges || 0);
        setTotalC(calculatedTotalC.toFixed(2));
    }, [localMseb, localInfraCharges, localSocietyFormationCharges, stampDutyParking, legalCharges, grossGovernmentCharges, costSheetData?.base_price, costSheetData?.stamp_duty, costSheetData?.floor_rise, costSheetData?.registration_price, costSheetData?.gst]);

    useEffect(() => {
        const calculatedGrandTotal =
            parseFloat(costSheetData?.base_price || 0) +
            parseFloat(totalB) +
            parseFloat(totalC);
        setGrandTotal(calculatedGrandTotal.toFixed(2));
    }, [localMseb, localInfraCharges, localSocietyFormationCharges, stampDutyParking, legalCharges, grossGovernmentCharges, costSheetData?.base_price, costSheetData?.stamp_duty, costSheetData?.floor_rise, costSheetData?.registration_price, costSheetData?.gst]);

    useEffect(() => {
        const fetchProjectSalesLogins = async () => {
            try {
                const response = await axiosInstance.get('/login', {
                    params: {
                        loginIdentifier: property?.propertyConfigData?.projectPhase?.project?.customerId,
                        personaType: "STAFF",
                    }
                });
                setApproverStaffLogins(response);
            } catch (error) {
                console.error("Error fetching approver staff logins:", error);
                toast.error("Failed to fetch approver staff logins");
            }
        };
        if (property?.propertyConfigData?.projectPhase?.project?.customerId) {
            fetchProjectSalesLogins();
        }
    }, [property?.propertyConfigData?.projectPhase?.project?.customerId]);

    const generateCostSheetHTML = () => {
        const html = costSheetTemplate({
            name: costSheetData.name || "",
            property_type: costSheetData.property_type || "",
            property_no: costSheetData.property_no || "",
            building_no: costSheetData.building_no || "",
            floor: costSheetData.floor || "",
            property_type_desc: costSheetData.property_type_desc || "",
            carpet_area: `${costSheetData.carpetAreaSqmt} SqMt / ${costSheetData.carpetAreaSqft} SqFt` || "",
            balcony_area: `${costSheetData.balconyAreaSqmt} SqMt / ${costSheetData.balconyAreaSqft} SqFt` || "",
            dry_balcony_area: `${costSheetData.dryBalconyAreaSqmt} SqMt / ${costSheetData.dryBalconyAreaSqft} SqFt` || "",
            total_area: `${costSheetData.superBuiltupAreaSqmt} SqMt / ${costSheetData.superBuiltupAreaSqft} SqFt` || "",
            base_price: costSheetData.base_price || "",
            floor_rise: costSheetData.floor_rise || "",
            stamp_duty: costSheetData.stamp_duty || "",
            stampDutyParking: stampDutyParking || "",
            registration_price: costSheetData.registration_price || "",
            gst: costSheetData.gst || "",
            legalCharges: legalCharges || "",
            grossGovernmentCharges: grossGovernmentCharges || "",
            totalB: totalB || "",
            totalC: totalC || "",
            grandTotal: grandTotal || "",
            costSheetTerms: costSheetData.cost_sheet_terms || "",
            mseb: localMseb || "",
            infraCharges: localInfraCharges || "",
            societyFormationCharges: localSocietyFormationCharges || "",
            tableStyle: "width: 100%; max-width: none;  border-collapse: collapse;",
            imageStyle: "max-width: 100%; height: auto;"
        });
        return html;
    };

    const handleSendDocumentWithValues = async () => {
        try {
            const updatedContent = generateCostSheetHTML();
            await onSendDocument(updatedContent);
            onClose();
        } catch (error) {
            console.error(`Error sending :`, error);
        }
    };

    const handlePreviewClick = () => {
        const htmlContent = generateCostSheetHTML();
        setPreviewHtml(htmlContent);
        setStep(3); // Change to step 3 since it's the last step
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Buyer selection is propagated to the parent by PropertyBuyerDetails'
        // own onCustomerSelect effect, which sends the full customer object
        // (with `.user.userId`). The previous code here pushed the raw scalar
        // value up and called an undefined setter — both removed.
    };

    const goToNextStep = () => setStep((prevStep) => prevStep + 1);
    const goToPreviousStep = () => setStep((prevStep) => prevStep - 1);

    const calculatePercentageValue = (baseValue, percentage) => {
        const base = parseFloat(baseValue) || 0;
        const percent = parseFloat(percentage) || 0;
        return (base * percent) / 100;
    };

    useEffect(() => {
        const basePrice = parseFloat(costSheetData?.base_price) || 0;
        if (selectedStampDutyPercent !== "") {
            const newStampDuty = calculatePercentageValue(basePrice, selectedStampDutyPercent);
            setCostSheetData(prevState => ({ ...prevState, stamp_duty: newStampDuty.toFixed(2) }));
        }
        if (selectedGstPercent !== "") {
            const newGST = calculatePercentageValue(basePrice, selectedGstPercent);
            setCostSheetData(prevState => ({ ...prevState, gst: newGST.toFixed(2) }));
        }
        if (selectedRegistrationPercent !== "") {
            const newRegistrationPrice = calculatePercentageValue(basePrice, selectedRegistrationPercent);
            setCostSheetData(prevState => ({ ...prevState, registration_price: newRegistrationPrice.toFixed(2) }));
        }
    }, [costSheetData?.base_price, selectedStampDutyPercent, selectedGstPercent, selectedRegistrationPercent]);

    const handleStampDutyChange = (e) => setCostSheetData(prevState => ({ ...prevState, stamp_duty: (parseFloat(e.target.value) || 0).toFixed(2) }));
    const handleGstChange = (e) => setCostSheetData(prevState => ({ ...prevState, gst: (parseFloat(e.target.value) || 0).toFixed(2) }));
    const handleRegistrationPriceChange = (e) => setCostSheetData(prevState => ({ ...prevState, registration_price: (parseFloat(e.target.value) || 0).toFixed(2) }));
    const handleMSEBChange = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setMseb(value);
        setLocalMseb(value);
    };
    const handleInfraChanges = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setInfraCharges(value);
        setLocalInfraCharges(value);
    };
    const handleSocietyFormationChargesChanges = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setSocietyFormationCharges(value);
        setLocalSocietyFormationCharges(value);
    };
    const handleStampDutyParkingChanges = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setStampDutyParking(value);
        setLocalStampDutyParking(value);
    };
    const handleLegalChargesChanges = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setLegalCharges(value);
        setLocalLegalCharges(value);
    };
    const handleGrossGovernmentChargesChanges = (e) => {
        const value = parseFloat(e.target.value) || 0;
        setGrossGovernmentCharges(value);
        setLocalGrossGovernmentCharges(value);
    };

    const handleStampDutyPercentChange = (e) => setSelectedStampDutyPercent(e.target.value);
    const handleGstPercentChange = (e) => setSelectedGstPercent(e.target.value);
    const handleRegistrationPercentChange = (e) => setSelectedRegistrationPercent(e.target.value);

    const handleApprovalDetailsChange = (e) => {
        const { name, value } = e.target;
        if (name === 'approver') {
            setSelectedLoginId(value);
            if (onLoginIdSelect) onLoginIdSelect(value);
        }
        setApprovalDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleCustomerSelect = (customer) => {
        if (onCustomerSelect) onCustomerSelect(customer);
    };

    const handleApprovalNeededChange = (e) => setApprovalNeeded(e.target.checked);
    const handleCommentChangeInput = (e) => setComment(e.target.value);

    const handleSendForApproval = async () => {
        // Guard: the BE requires a buyer (userId). Surface a clear message
        // instead of letting the request 422 if no buyer is selected.
        const buyerUserId = selectedUser?.user?.userId;
        if (!buyerUserId) {
            toast.error("Please select a buyer before sending the cost sheet.");
            return;
        }
        setIsSending(true);
        try {
            const updatedContent = generateCostSheetHTML();
            const requiresApproval = approvalNeeded;
            const response = await axiosInstance.post(`/approvals?requiresApproval=${requiresApproval}`, {
                approvalTypeId: 1,
                requesterLoginId: userInfo?.loginId,
                approverLoginId: approver ? approver : userInfo?.loginId,
                userId: buyerUserId,
                customerId: userInfo.loginIdentifierDetails.customer.customerId,
                projectPhaseId: property.propertyData.projectPhase.projectPhaseId,
                propertyId: property.propertyData.propertyId,
                status: approvalNeeded ? "PENDING" : "APPROVED",
                comment: comment || "",
                //approvalDatetime: new Date().toISOString().split("T")[0],
                attachment: updatedContent
            });
            toast.success(requiresApproval ? "Cost Sheet sent for approval!" : "Cost Sheet sent directly!");
            onClose();
        } catch (error) {
            console.error("Error sending for approval:", error);
            toast.error("Failed to send for approval. Please check console for errors.");
        } finally {
            setIsSending(false);
        }
    };

    if (!costSheetData) return <div>Loading...</div>;

    // No own modal shell / no width cap — the parent (Properties.jsx or
    // PaymentInstallmentsTab.jsx) wraps this in <FormModal size="2xl">.
    // Title is supplied by FormModal too, so we don't render our own h2.
    return (
        <div className="w-full">
            {step === 1 && (
                <PropertyBuyerDetails
                    formData={formData}
                    handleInputChange={handleInputChange}
                    property={property.propertyData}
                    customers={customers}
                    onCustomerSelect={handleCustomerSelect}
                    userInfo={userInfo}
                    fullProperty={property}
                />
            )}
            {step === 2 && (
                <form className="grid grid-cols-1 gap-4">
                    <section className="mb-4">
                        <h3 className="text-xl font-semibold mb-2">Unit Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <CustomInput label="Carpet Area" value={`${costSheetData.carpetAreaSqmt} SqMt / ${costSheetData.carpetAreaSqft} SqFt`} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                            <CustomInput label="Balcony Area" value={`${costSheetData.balconyAreaSqmt} SqMt / ${costSheetData.balconyAreaSqft} SqFt`} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                            <CustomInput label="Dry Balcony Area" value={`${costSheetData.dryBalconyAreaSqmt} SqMt / ${costSheetData.dryBalconyAreaSqft} SqFt`} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                            <CustomInput label="Total Area" value={`${costSheetData.superBuiltupAreaSqmt} SqMt / ${costSheetData.superBuiltupAreaSqft} SqFt`} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                        </div>
                    </section>
                    <section className="mb-4">
                        <h3 className="text-xl font-semibold mb-2">Agreement Value (A)</h3>
                        <CustomInput label="Agreement Value" type="number" value={costSheetData.base_price} style={{ backgroundColor: "#f3f4f6" }} onChange={(e) => setCostSheetData(prevState => ({ ...prevState, base_price: e.target.value }))} />
                        <CustomInput label="Floor Rise" value={costSheetData.floor_rise} style={{ backgroundColor: "#f3f4f6" }} onChange={(e) => setCostSheetData(prevState => ({ ...prevState, floor_rise: e.target.value }))} />
                    </section>
                    <section className="mb-4">
                        <h3 className="text-xl font-semibold mb-2">Other Charges (B)</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <CustomInput label="MSEB" type="number" value={localMseb} onChange={handleMSEBChange} />
                            <CustomInput label="Infra Charges" type="number" value={localInfraCharges} onChange={handleInfraChanges} />
                            <CustomInput label="Society Formation Charges" type="number" value={localSocietyFormationCharges} onChange={handleSocietyFormationChargesChanges} />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <CustomInput label="Total B" type="number" value={totalB} readOnly style={{ backgroundColor: "#f3f4f6" }} />
                        </div>
                    </section>
                    <section className="mb-4">
                        <h3 className="text-xl font-semibold mb-2">Government Charges (C)</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label className="block text-sm font-normal text-gray-700 mb-1">Stamp Duty</label>
                                <div className="flex items-center gap-2">
                                    <select className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10" value={selectedStampDutyPercent} onChange={handleStampDutyPercentChange} id="stampDutyPercent">
                                        <option value="" disabled={selectedStampDutyPercent !== ""}>Select %</option>
                                        {stampDutyPercentsDropDown.map((percent, index) => <option key={index} value={percent}>{percent}%</option>)}
                                    </select>
                                    <Input.Field type="number" id="stampDuty" name="stampDuty" value={costSheetData.stamp_duty} onChange={handleStampDutyChange} className="w-2/3 h-10 rounded-lg" />
                                </div>
                            </div>
                            <CustomInput label="Stamp Duty on Parking" type="number" value={stampDutyParking} onChange={handleStampDutyParkingChanges} />
                            <div>
                                <label className="block text-sm font-normal text-gray-700 mb-1">Registration</label>
                                <div className="flex items-center gap-2">
                                    <select className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10" value={selectedRegistrationPercent} onChange={handleRegistrationPercentChange} id="registrationPercent">
                                        <option value="" disabled={selectedRegistrationPercent !== ""}>Select %</option>
                                        {registrationPercentsDropDown.map((percent, index) => <option key={index} value={percent}>{percent}%</option>)}
                                    </select>
                                    <Input.Field type="number" id="registrationPrice" name="registrationPrice" value={costSheetData.registration_price} onChange={handleRegistrationPriceChange} className="w-2/3 h-10 rounded-lg" />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-normal text-gray-700 mb-1">GST</label>
                                <div className="flex items-center gap-2">
                                    <select className="w-1/3 p-2 my-2 border-2 border-gray-100 rounded-lg bg-white text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 focus:outline-none h-10" value={selectedGstPercent} onChange={handleGstPercentChange} id="gstPercent">
                                        <option value="" disabled={selectedGstPercent !== ""}>Select %</option>
                                        {gstPercentsDropDown.map((percent, index) => <option key={index} value={percent}>{percent}%</option>)}
                                    </select>
                                    <Input.Field type="number" id="gst" name="gst" value={costSheetData.gst} onChange={handleGstChange} className="w-2/3 h-10 rounded-lg" />
                                </div>
                            </div>
                            <CustomInput label="Legal Charges" type="number" value={legalCharges} onChange={handleLegalChargesChanges} />
                            <CustomInput label="Gross Government Charges" type="number" value={grossGovernmentCharges} onChange={handleGrossGovernmentChargesChanges} />
                        </div>
                        <CustomInput label="Total C" type="number" value={totalC} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                    </section>
                    <CustomInput label=" Grand Total (A+B+C)" type="number" value={grandTotal} style={{ backgroundColor: "#f3f4f6" }} readOnly />
                    <div className="mb-4">
                        <label className="block text-sm font-semibold mb-1">Terms & Conditions</label>
                        <textarea className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" rows={4} value={costSheetTerms} onChange={e => { setCostSheetTerms(e.target.value); setCostSheetData(prev => ({ ...prev, cost_sheet_terms: e.target.value })); }} placeholder="Enter terms and conditions here..." />
                    </div>
                </form>
            )}
            {step === 3 && (
                <section className="mt-8">
                    <div className="flex flex-col items-center w-full">
                        <div className="flex-1 border rounded-lg bg-white flex flex-col items-center relative w-full max-w-4xl max-h-[75vh] pb-28">
                            <div className="absolute top-2 right-2 z-10">
                                <button
                                    onClick={() => setIsFullScreen(true)}
                                    className="p-2 bg-gray-200 rounded-full hover:bg-gray-300 transition-colors"
                                    title="Expand Document"
                                >
                                    <Expand size={20} />
                                </button>
                            </div>
                            <iframe title="Cost Sheet Preview" srcDoc={previewHtml} style={{ width: "794px", minHeight: "1000px", border: "none", background: "white", margin: "20px 0", transform: "scale(0.5)", transformOrigin: "top center" }} />
                            <div className="absolute bottom-0 left-0 right-0 flex flex-col gap-2 p-4 border-t bg-gray-50">
                                <div className="flex items-center mb-2">
                                    <input type="checkbox" id="approvalNeeded" checked={approvalNeeded} onChange={handleApprovalNeededChange} className="mr-2 h-5 w-5 text-blue-500 focus:ring-blue-500 border-gray-300 rounded" />
                                    <label htmlFor="approvalNeeded" className="text-sm font-medium text-gray-700">Send for Approval?</label>
                                </div>
                                <div className="flex justify-end gap-4">
                                    <OutlineButton className={"w-32"} onClick={goToPreviousStep}>Back</OutlineButton>
                                    {approvalNeeded ? (
                                        <PrimaryButton className={"w-32"} onClick={goToNextStep}>Next</PrimaryButton>
                                    ) : (
                                        <PrimaryButton className={"w-32"} onClick={handleSendForApproval} disabled={isSending}>
                                            {isSending ? (
                                                <div className="flex items-center space-x-2">
                                                    <Spinner className="w-4 h-4" />
                                                    <span>Sending...</span>
                                                </div>
                                            ) : (
                                                "Send"
                                            )}
                                        </PrimaryButton>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
            {isFullScreen && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70">
                    <div className="bg-white rounded-lg shadow-2xl relative w-[90vw] h-[90vh] flex flex-col overflow-hidden">
                        <button
                            onClick={() => setIsFullScreen(false)}
                            className="absolute top-4 right-4 z-50 p-2 bg-gray-100 rounded-full text-black hover:bg-gray-200 transition-colors"
                            title="Close Fullscreen"
                        >
                            <X size={28} />
                        </button>
                        <iframe
                            title="Full Screen Cost Sheet Preview"
                            srcDoc={previewHtml}
                            className="flex-1 w-full h-full"
                            style={{
                                border: "none",
                                background: "white",
                                margin: 0,
                                padding: 0,
                                minHeight: "100%",
                                minWidth: "100%",
                                boxShadow: "none"
                            }}
                        />
                    </div>
                </div>
            )}
            {step === 4 && approvalNeeded && (
                <section className="mt-8 w-[700px] mx-auto">
                    <h3 className="text-xl font-semibold mb-4">Approval Details</h3>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Select Approver</label>
                            <select name="approver" value={approvalDetails.approver} onChange={handleApprovalDetailsChange} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option value="">Select an approver</option>
                                {approverStaffLogins.map((login) => <option key={login.loginId} value={login.loginId}>{login.name}</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Comments</label>
                            <textarea name="comment" value={comment} onChange={handleCommentChangeInput} rows="4" className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter any additional comments..." />
                        </div>
                        <div className="flex justify-end gap-4 mt-6">
                            <OutlineButton className={"w-32"} onClick={goToPreviousStep}>Back</OutlineButton>
                            <PrimaryButton className={"w-32"} onClick={handleSendForApproval} disabled={isSending || !selectedLoginId}>
                                {isSending ? (
                                    <div className="flex items-center space-x-2">
                                        <Spinner className="w-4 h-4" />
                                        <span>Sending...</span>
                                    </div>
                                ) : (
                                    "Send"
                                )}
                            </PrimaryButton>
                        </div>
                    </div>
                </section>
            )}
            {step < 3 && (
                <div className="flex justify-end gap-4 mt-6">
                    {step > 1 && (<OutlineButton className={"w-32"} onClick={goToPreviousStep}>Back</OutlineButton>)}
                    {step < 2 && (<PrimaryButton className={"w-32"} onClick={goToNextStep}>Next</PrimaryButton>)}
                    {step === 2 && (<PrimaryButton className={"w-32"} onClick={handlePreviewClick}>Preview</PrimaryButton>)}
                </div>
            )}

           
        </div>
    );
};

CostSheetFormModal.displayName = "CostSheetFormModal";

export default CostSheetFormModal;